import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wallShade',
      d: 'M-0.5,-14.5h1v0.5h-1zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5zM-4,0h2v0.5h-2zM2,0h2v0.5h-2z',
    },
    {
      paint: 'boulder',
      d: 'M-0.5,-14h1v1h-1zM0,-12h0.5v0.5h-0.5zM0,-11.5h1v1.5h-1zM-0.5,-10h1.5v1h-1.5zM0,-9h1v0.5h-1zM-0.5,-8h2v0.5h-2zM0.5,-7.5h1v0.5h-1zM1,-7h0.5v0.5h-0.5zM1,-6.5h1v1h-1zM1.5,-5.5h0.5v1h-0.5zM2,-4h0.5v0.5h-0.5zM-1.5,-3.5h4.5v0.5h-4.5zM-2,-3h5v0.5h-5zM-2,-2.5h1v0.5h-1zM1,-2.5h1v0.5h-1zM2.5,-2.5h0.5v0.5h-0.5zM-2.5,-2h1v0.5h-1zM1.5,-2h2v0.5h-2zM-2.5,-1.5h0.5v1h-0.5zM2,-1.5h1.5v1h-1.5zM-4,-0.5h0.5v0.5h-0.5zM-3,-0.5h0.5v0.5h-0.5zM2.5,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'rock',
      d: 'M-1,-13h2v1h-2zM-0.5,-12h0.5v0.5h-0.5zM-1,-11.5h1v1.5h-1zM-1,-10h0.5v1h-0.5zM-1,-9h1v0.5h-1zM-1.5,-8.5h3v0.5h-3zM-1.5,-8h1v0.5h-1zM-1.5,-7.5h2v0.5h-2zM-1.5,-7h2.5v0.5h-2.5zM-2,-6.5h1.5v0.5h-1.5zM0.5,-6.5h0.5v0.5h-0.5zM-2,-6h3v1h-3zM-2.5,-5h2v0.5h-2zM0.5,-5h1v0.5h-1zM-2.5,-4.5h5v0.5h-5zM-2.5,-4h4.5v0.5h-4.5zM-3,-3.5h1.5v0.5h-1.5zM-3,-3h1v1h-1zM2,-2.5h0.5v0.5h-0.5zM-3.5,-2h1v1.5h-1zM-3.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'epicMarble',
      d: 'M-1.5,-9h0.5v0.5h-0.5zM1,-9h0.5v0.5h-0.5zM-0.5,-5h1v0.5h-1zM2,-5h0.5v0.5h-0.5z',
    },
    { paint: 'epicGold', d: 'M-0.5,-15h1v0.5h-1z' },
  ],
  pixels: 187,
};
export const sprites: readonly PixelSprite[] = [variant0];
